<template>
  <ModalPrimary v-bind="modalAttrs"
                :name="modalName"
                @before-open="beforeModalOpen">
    <div :style="containerStyle">
      <HeaderLargePrimary :style="headerStyle">
        Rename team
      </HeaderLargePrimary>
      <div :style="formContainerStyle">
        <InputTextSecondary placeholder="Enter new team name"
                            v-model="tenantTeamName" />
      </div>
      <div :style="buttonsContainerStyle">
        <ButtonSecondary :style="cancelButtonStyle"
                         @click="cancel">
          Cancel
        </ButtonSecondary>
        <ButtonPrimary :disabled="disableSave"
                       :style="saveButtonStyle"
                       @click="renameTenantTeam">
          Save
        </ButtonPrimary>
      </div>
    </div>
  </ModalPrimary>
</template>

<script>
  import ApiTenantTeam from '@js/api/tenant-team'
  import ButtonPrimary from '@modules/button/button-primary'
  import ButtonSecondary from '@modules/button/button-secondary'
  import HeaderLargePrimary from '@modules/text/header-large-primary'
  import InputTextSecondary from '@modules/input/input-text-secondary'
  import ModalPrimary from '@modules/modal/modal-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalRenameTenantTeam',
    components: {
      ButtonPrimary,
      ButtonSecondary,
      HeaderLargePrimary,
      InputTextSecondary,
      ModalPrimary,
    },
    data: function () {
      return {
        buttonsContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        },
        cancelButtonStyle: {
          minWidth: '80px',
        },
        containerStyle: {
          alignItems: 'flex-start',
          display: 'flex',
          flexDirection: 'column',
          height: '174px',
          justifyContent: 'space-between',
          width: '100%',
        },
        formContainerStyle: {
          width: '100%',
        },
        headerStyle: {
          lineHeight: FontStyle.size.lg,
        },
        initTenantTeamName: '',
        modalAttrs: {
          maxWidth: 400,
          minHeight: 300,
        },
        modalName: MODAL_WINDOW_NAMES.RENAME_TENANT_TEAM_PRIMARY,
        saveButtonStyle: {
          minWidth: '66px',
        },
        tenantTeamId: null,
        tenantTeamName: '',
      };
    },
    computed: {
      disableSave: function () {
        return this.tenantTeamName.trim().length === 0 || this.initTenantTeamName.trim() === this.tenantTeamName.trim();
      },
    },
    methods: {
      beforeModalOpen: function (e) {
        this.initTenantTeamName = e.params ? (e.params.tenantTeamName ?  e.params.tenantTeamName : '') : '';
        this.tenantTeamId = e.params ? (e.params.tenantTeamId ? e.params.tenantTeamId : null) : null;
        this.tenantTeamName = this.initTenantTeamName;
      },
      cancel: function () {
        this.close();
      },
      clear: function () {
        this.initTenantTeamName = '';
        this.tenantTeamId = null;
        this.tenantTeamName = '';
      },
      close: function () {
        this.clear();
        this.$modal.hide(this.modalName);
      },
      renameTenantTeam: async function () {
        try {
          const payload = await {
            name: this.tenantTeamName,
          };
          const api = await new ApiTenantTeam(this.tenantTeamId);
          const res = await api.put(payload);
          await this.$emit('renamed-tenant-team', this.tenantTeamName);
          await this.$store.commit('notification/setMessage', `Renamed team`)
          await this.close();
        } catch (error) {
          this.$store.commit('notification/setWarning', 'Failed to rename the team');
          console.error(error);
        }
      },
    },
  };
</script>

